import { config } from "./domainConfig";

export const getContactLinks = (subdomain) => {
  const mobioTVURL = "https://mobiotv.com/customer-care/?subdomain=";
  const mobiofitURL = "https://mobiofit.com/customer-care/?subdomain=";
  if (subdomain === "sa" && config.newDomain !== "mobiofitpro")
    return mobioTVURL + "sa";
  else if (subdomain === "sa.mobiofit") return mobiofitURL + "sa";
  else if (subdomain === "ae.mobiofit") return mobiofitURL + "ae";
  else return null;
};



// WEBPACK FOOTER //
// ./src/constants/contactLinks.js